// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3gLJF","fileBtn":"File_fileBtn__3qLgb","closeBtn":"File_closeBtn__3D9x6","fileSelected":"File_fileSelected__20TPr","disabled":"File_disabled__1lfVm"};